import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalGeneralComponent } from '../modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, MatSelectModule, TranslateModule],
  templateUrl: './user-settings.component.html',
  styleUrl: './user-settings.component.scss'
})
export class UserSettingsComponent {

  constructor(private http: HttpClient, public dialog: MatDialog, private translate: TranslateService, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    this.language = localStorage.getItem('language_conectio_client') || 'es';
  }

  currentProfileImageUrl: string = "https://conectio.es:8000/" + localStorage.getItem('profile_image');  // Replace with your current profile image URL or logic to fetch it

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef; 
  selectedFile!: File;
  currentPassword!: string;
  newPassword!: string;
  errorPass: any = false;
  language: string = localStorage.getItem('language_conectio_client') || 'es';
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files[0]) {
      this.selectedFile = input.files[0];
      // Logic to handle the file upload or display a preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.currentProfileImageUrl = e.target.result;  // Preview the new image
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }


  onUpload(): void {
    if (this.selectedFile) {

      const headers = new HttpHeaders({
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      });

      const formData: FormData = new FormData();
      formData.append('image', this.selectedFile, this.selectedFile.name);

      this.http.post(`${environment.url}/api/user/update_image`, formData, { headers: headers }).subscribe(
        (response: any) => {
          this.dialog.open(ModalGeneralComponent, {
            data: {
              title: this.translate.instant('userSettings.messages.imageUpdated.title'),
              message: this.translate.instant('userSettings.messages.imageUpdated.message'),
              buttonText: this.translate.instant('common.modal.buttonText'),
              type: 'success'
            }
          });
        },
        (error: any) => {
          this.dialog.open(ModalGeneralComponent, {
            data: {
              title: this.translate.instant('userSettings.messages.error.title'),
              message: this.translate.instant('userSettings.messages.error.imageUpdate'),
              buttonText: this.translate.instant('common.modal.buttonText'),
              type: 'error'
            }
          });
        }
      );
    }
  }

  changePassword(): void {
    this.http.post(`${environment.url}/api/user/change_password`, { "current_password": this.currentPassword, "new_password":this.newPassword } ).subscribe(
      (response: any) => {
        this.errorPass = false;
        this.currentPassword = "";
        this.newPassword = "";
        this.dialog.open(ModalGeneralComponent, {
          data: {
            title: this.translate.instant('userSettings.messages.passwordUpdated.title'),
            message: this.translate.instant('userSettings.messages.passwordUpdated.message'),
            buttonText: this.translate.instant('common.modal.buttonText'),
            type: 'success'
          }
        });
      },
      error => {
        this.errorPass = true;
        this.dialog.open(ModalGeneralComponent, {
          data: {
            title: this.translate.instant('userSettings.messages.error.title'), 
            message: this.translate.instant('userSettings.messages.error.passwordUpdate'),
            buttonText: this.translate.instant('common.modal.buttonText'),
            type: 'error'
          }
        });
      }
    );
  }

  cambiarIdioma(event: any) {

    let lang = event;

    this.translate.use(lang);

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('language_conectio_client', lang);
    }
  }

}
